import React, { useEffect, useState, useCallback } from "react";
import TableWithSkeleton from "../../../../components/table/TableWithSkeleton";
import tradeColumns from "../../../../columns/trades.jsx";
import { CloseMT5TradeApi, GetOpenPositionApi } from "../../../../api/request/liveAccount.js";
import toast from "react-hot-toast";
import { handleApiError } from "../../../../utils/handleApiError.js";

const POLLING_INTERVAL = 10000;

const OpenTrades = ({ loginId }) => {
  const [liveData, setLiveData] = useState([]);

  const handleCloseTrade = async (login, positionId) => {
    try {
      const payload = {
        loginId: login,
        positionId: [positionId],
      };

      const res = await CloseMT5TradeApi(payload);
      if (res?.data?.success) {
        setLiveData((prev) =>
          prev.filter((item) => item.positionId !== positionId)
        );
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const mapTradeData = useCallback((items) => {
    return items?.map((item) => ({
      ...item,
      close: (
        <button
          onClick={() => handleCloseTrade(item.login, item.positionId)}
        >
          <svg
            viewBox="0 0 1024 1024"
            xmlns="http://www.w3.org/2000/svg"
            fill="#D91819"
            className="w-6 h-6 cursor-pointer hover:fill-[#aa0001] duration-500"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path
                fill="#D91819"
                d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
              ></path>
            </g>
          </svg>
        </button>
      ),
    })) || [];
  }, []);

  const fetchData = useCallback(async () => {
    if (!loginId) return;
    try {
      const { data } = await GetOpenPositionApi(loginId);
      if (data?.success) {
        const items = Array.isArray(data?.data) ? data.data : data?.data?.data || [];
        setLiveData(mapTradeData(items));
      }
    } catch (error) { }
  }, [loginId, mapTradeData]);

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, [fetchData]);

  return <TableWithSkeleton columns={tradeColumns} data={liveData} />;
};

export default OpenTrades;
